import { useEffect, useState } from 'react';
import { EXIT } from './motion';

/**
 * Keeps something on screen a moment after it should go, so it can leave with
 * an animation instead of vanishing. `leaving` is true for that moment.
 * Request of 5 October 2026, section 6.
 */
export function usePresence(
  present: boolean,
  ms: number = EXIT.normal,
): { shown: boolean; leaving: boolean } {
  const [shown, setShown] = useState(present);

  useEffect(() => {
    if (present) {
      setShown(true);
      return;
    }
    const timer = setTimeout(() => setShown(false), ms);
    return () => clearTimeout(timer);
  }, [present, ms]);

  return { shown: present || shown, leaving: !present && shown };
}
